import React from 'react';
import { useSelector } from 'react-redux';

import KPTextform from '../../../../components/KPTComponents/KPTextform';
import { RESEARCHPROJECTS_CONSTANTS } from '../../../../constants';
import { Box } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { SECONDARY_COLOR } from '../../../../constants/enums';
import { getQcvScoreOptions } from '../../../../utils/qcvScoreOptions';

// authorEditable=true: chỉ mở trường số tác giả chính (màn duyệt thưởng).
export const researchProjectForm = (values, disabled, levelOptions = RESEARCHPROJECTS_CONSTANTS.LEVEL_OPTIONS, authorEditable = false) => {
  // "Vai trò" (Chủ trì/Đồng chủ trì) không bắt buộc với đề tài cấp Nhà nước.
  // Tra theo MÔ TẢ (không hardcode key cũ) để không vỡ khi code đổi theo mùa.
  const nhaNuocCode = (levelOptions || []).find((o) => o.title?.includes('Nhà nước'))?.value;

  return [
  { key: 'title', width: 12, height: 1, label: 'Tên đề tài', disabled, required: true },
  { key: 'start_at', width: 6, label: 'Thời gian thực hiện',type:'date', disabled, required: true },
  { key: 'finish_at', width: 6, label: 'Thời gian kết thúc',type:'date', disabled, required: true },
  { key: 'unit', width: 12, height: 1, label: 'Cơ quan, tổ chức chủ trì', disabled, required: true },
  {
    key: 'level',
    width: 12,
    label: 'Cấp đề tài',
    options: levelOptions,
    disabled,
    required: true,
    note: (
      <Box display="flex" alignItems="center" style={{ color: SECONDARY_COLOR }}>
        <InfoOutlined style={{ width: 16 }} />
        &nbsp;<b>Lưu ý:</b>&nbsp;Chỉ tính những đề tài đã được nghiệm thu!
      </Box>
    )
  },
  { key: 'numberMain', width: 6, label: 'Số tác giả chính', type: 'int', disabled: authorEditable ? false : disabled, required: true },
  {
    key: 'type',
    width: 6,
    label: 'Vai trò',
    options: RESEARCHPROJECTS_CONSTANTS.TYPO_OPTIONS,
    disabled,
    required: values?.level !== nhaNuocCode
  },
  { key: 'previewFile', width: 12, type: 'file', value: values?.link, disabled, required: true },
  ];
};

export default function DuAnForm(props) {
	const { values, disabled } = props;

  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  // Mục 4 (bảng điểm QCV): "Cấp đề tài" lấy động từ qcv_score_infos (code 4.x).
  const muc4Options = getQcvScoreOptions(scoreInformationList, '4');
  const levelOptions = muc4Options.length ? muc4Options : RESEARCHPROJECTS_CONSTANTS.LEVEL_OPTIONS;

  const textForm = researchProjectForm(values, disabled, levelOptions, props.authorEditable);

  return <KPTextform {...props} textForm={textForm} />;
}
